import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@perval/shared';
import { firstValueFrom } from 'rxjs';
import { Utilisateur } from '../../../utilisateur/models/utilisateur';

@Injectable({
  providedIn: 'root',
})
export class EmailService {
  private readonly mainUrl = `${environment.baseApiUrl}/perval-email`;

  constructor(private readonly http: HttpClient) {}

  async sendEmailConfirmationUtilisateur(
    utilisateur: Utilisateur,
  ): Promise<void> {
    const content = {
      nom: utilisateur.nom,
      prenom: utilisateur.prenom,
      login: utilisateur.login,
    };

    await this.sendEmail(utilisateur.email, 'confirmationUtilisateur', content);
  }

  async sendEmailValidationGestionnaire(
    utilisateur: Utilisateur,
    gestionnaire: Utilisateur,
  ): Promise<void> {
    const content = {
      nomUtilisateur: utilisateur.nom,
      prenomUtilisateur: utilisateur.prenom,
      emailUtilisateur: utilisateur.email,
      nomGestionnaire: gestionnaire.nom,
      prenomGestionnaire: gestionnaire.prenom,
    };

    await this.sendEmail(gestionnaire.email, 'validationGestionnaire', content);
  }

  async sendEmailConfirmationGestionnaire(
    utilisateur: Utilisateur,
    gestionnaire: Utilisateur,
  ): Promise<void> {
    const content = {
      nomUtilisateur: utilisateur.nom,
      prenomUtilisateur: utilisateur.prenom,
      loginUtilisateur: utilisateur.login,
      nomGestionnaire: gestionnaire.nom,
      prenomGestionnaire: gestionnaire.prenom,
    };

    await this.sendEmail(
      gestionnaire.email,
      'confirmationGestionnaire',
      content,
    );
  }

  private async sendEmail(
    email: string,
    nature: string,
    content: object,
  ): Promise<void> {
    const type: string = 'mime';
    const mime: string = '';

    await firstValueFrom(
      this.http.post(`${this.mainUrl}/smtp`, {
        type: type,
        mime: mime,
        email: email,
        nature: nature,
        content: content,
      }),
    );
  }
}
